module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.activeName != 'first') ? _c('el-card', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [(_vm.activeName != 'first') ? _c('el-alert', {
    attrs: {
      "title": "统计信息",
      "type": "success",
      "description": "每天早上8时自动更新前一天数据.",
      "show-icon": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "id查询",
      "size": "mini"
    },
    model: {
      value: (_vm.params.id),
      callback: function($$v) {
        _vm.$set(_vm.params, "id", $$v)
      },
      expression: "params.id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "名称",
      "size": "mini"
    },
    model: {
      value: (_vm.params.name),
      callback: function($$v) {
        _vm.$set(_vm.params, "name", $$v)
      },
      expression: "params.name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分享类型",
      "size": "mini"
    },
    model: {
      value: (_vm.params.type),
      callback: function($$v) {
        _vm.$set(_vm.params, "type", $$v)
      },
      expression: "params.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "商品",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "活动",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "其他",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "来源",
      "size": "mini"
    },
    model: {
      value: (_vm.params.origin),
      callback: function($$v) {
        _vm.$set(_vm.params, "origin", $$v)
      },
      expression: "params.origin"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "其他",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "商城",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "多店铺",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "怡康优选",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "size": "mini",
      "type": "datetimerange",
      "picker-options": _vm.pickerOptions,
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "align": "right"
    },
    model: {
      value: (_vm.params.times),
      callback: function($$v) {
        _vm.$set(_vm.params, "times", $$v)
      },
      expression: "params.times"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.exportData()
      }
    }
  }, [_vm._v("导出数据")]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "content": "注意:最多只能导出开始和结束不超过一个月的数据!"
    }
  }, [_c('i', {
    staticClass: "el-icon-question",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1)], 1)], 1) : _c('el-card', [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    staticClass: "iconfont icon-sync-alt",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.changeClick()
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.corpName))]), _vm._v(" "), _c('depTree', {
    attrs: {
      "visible": _vm.visible,
      "data": _vm.checked
    },
    on: {
      "onClose": _vm.handleClose,
      "change": _vm.handleChange
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "手机号",
      "size": "mini"
    },
    model: {
      value: (_vm.params.mobile),
      callback: function($$v) {
        _vm.$set(_vm.params, "mobile", $$v)
      },
      expression: "params.mobile"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "店铺id",
      "size": "mini"
    },
    model: {
      value: (_vm.params.distributor_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "distributor_id", $$v)
      },
      expression: "params.distributor_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "商品id",
      "size": "mini"
    },
    model: {
      value: (_vm.params.item_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "item_id", $$v)
      },
      expression: "params.item_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "货号",
      "size": "mini"
    },
    model: {
      value: (_vm.params.item_bn),
      callback: function($$v) {
        _vm.$set(_vm.params, "item_bn", $$v)
      },
      expression: "params.item_bn"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "活动id",
      "size": "mini"
    },
    model: {
      value: (_vm.params.active_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "active_id", $$v)
      },
      expression: "params.active_id"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "店铺名称",
      "size": "mini"
    },
    model: {
      value: (_vm.params.distributor_name),
      callback: function($$v) {
        _vm.$set(_vm.params, "distributor_name", $$v)
      },
      expression: "params.distributor_name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "活动名称",
      "size": "mini"
    },
    model: {
      value: (_vm.params.active_name),
      callback: function($$v) {
        _vm.$set(_vm.params, "active_name", $$v)
      },
      expression: "params.active_name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "商品名称",
      "size": "mini"
    },
    model: {
      value: (_vm.params.title),
      callback: function($$v) {
        _vm.$set(_vm.params, "title", $$v)
      },
      expression: "params.title"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分享类型",
      "size": "mini"
    },
    model: {
      value: (_vm.params.type),
      callback: function($$v) {
        _vm.$set(_vm.params, "type", $$v)
      },
      expression: "params.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "商品",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "活动",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "其他",
      "value": "2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "来源",
      "size": "mini"
    },
    model: {
      value: (_vm.params.origin),
      callback: function($$v) {
        _vm.$set(_vm.params, "origin", $$v)
      },
      expression: "params.origin"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "其他",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "商城",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "多店铺",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "怡康优选",
      "value": "3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "用户id",
      "size": "mini"
    },
    model: {
      value: (_vm.params.user_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "user_id", $$v)
      },
      expression: "params.user_id"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "转发人名称",
      "size": "mini"
    },
    model: {
      value: (_vm.params.realname),
      callback: function($$v) {
        _vm.$set(_vm.params, "realname", $$v)
      },
      expression: "params.realname"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('el-date-picker', {
    attrs: {
      "size": "mini",
      "type": "datetimerange",
      "picker-options": _vm.pickerOptions,
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "align": "right"
    },
    model: {
      value: (_vm.params.times),
      callback: function($$v) {
        _vm.$set(_vm.params, "times", $$v)
      },
      expression: "params.times"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.searchData
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.exportData()
      }
    }
  }, [_vm._v("导出数据")]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "content": "注意:最多只能导出开始和结束不超过一个月的数据!"
    }
  }, [_c('i', {
    staticClass: "el-icon-question",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1)], 1)], 1), _vm._v(" "), _c('el-tabs', {
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "分享列表",
      "name": "first"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.catesList,
      "height": _vm.wheight - 130
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_id",
      "label": "商品id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "部门*店铺"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('p', [_vm._v("\n              " + _vm._s(scope.row.department_name) + "\n              "), (scope.row.distributor_id) ? _c('span', [_vm._v("(\n                "), _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "success"
          }
        }, [_vm._v(_vm._s(scope.row.distributor_name))]), _vm._v(")")], 1) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v("部门id: " + _vm._s(scope.row.department_id))]), _vm._v(" "), (scope.row.distributor_id) ? _c('p', [_vm._v("\n              店铺id: " + _vm._s(scope.row.distributor_id) + "\n            ")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realname",
      "label": "转发人名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', [_vm._v("链接: " + _vm._s(scope.row.url))]), _vm._v(" "), (scope.row.item_bn) ? _c('p', [_vm._v("货号: " + _vm._s(scope.row.item_bn))]) : _vm._e(), _vm._v(" "), (scope.row.active_id) ? _c('p', [_vm._v("\n                活动id: " + _vm._s(scope.row.active_id) + "\n              ")]) : _vm._e(), _vm._v(" "), (scope.row.active_name) ? _c('p', [_vm._v("\n                活动: " + _vm._s(scope.row.active_name) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          }
        }, [_vm._v(_vm._s(scope.row.realname))])], 1)])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "分享类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == '0') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "success"
          }
        }, [_vm._v("商品")]) : (scope.row.type == '1') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("活动")]) : (scope.row.type == '2') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("其他")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin",
      "label": "来源",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.origin == '0') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "default"
          }
        }, [_vm._v("其他")]) : (scope.row.origin == '1') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("商城")]) : (scope.row.origin == '2') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "danger"
          }
        }, [_vm._v("多店铺")]) : _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "warning"
          }
        }, [_vm._v("怡康优选")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "label": "更新时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm._f("datetime")(scope.row.create_time, "yyyy-MM-dd hh:mm:ss")))]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "分享次数统计",
      "name": "times"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList1
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "origin_0",
      "label": "其他"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin_1",
      "label": "商城"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin_2",
      "label": "多店铺"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "origin_3",
      "label": "怡康优选"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "时间"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "用户分享次数统计",
      "name": "user"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList2
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "user_id",
      "label": "成员id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "来源"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.origin == '0') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "default"
          }
        }, [_vm._v("其他")]) : (scope.row.origin == '1') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("商城")]) : (scope.row.origin == '2') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "danger"
          }
        }, [_vm._v("多店铺")]) : _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "warning"
          }
        }, [_vm._v("怡康优选")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "分享类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == '0') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "success"
          }
        }, [_vm._v("商品")]) : (scope.row.type == '1') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("活动")]) : (scope.row.type == '2') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("其他")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "总数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "时间"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "商品分享次数统计",
      "name": "item"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList3
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "item_id",
      "label": "商品id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "分享类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == '0') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "success"
          }
        }, [_vm._v("商品")]) : (scope.row.type == '1') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("活动")]) : (scope.row.type == '2') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("其他")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "来源"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.origin == '0') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "default"
          }
        }, [_vm._v("其他")]) : (scope.row.origin == '1') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("商城")]) : (scope.row.origin == '2') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "danger"
          }
        }, [_vm._v("多店铺")]) : _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "warning"
          }
        }, [_vm._v("怡康优选")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "总数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "时间"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "部门分享次数统计",
      "name": "department"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList4
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "department_id",
      "label": "部门id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "分享类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == '0') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "success"
          }
        }, [_vm._v("商品")]) : (scope.row.type == '1') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("活动")]) : (scope.row.type == '2') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("其他")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "来源"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.origin == '0') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "default"
          }
        }, [_vm._v("其他")]) : (scope.row.origin == '1') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("商城")]) : (scope.row.origin == '2') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "danger"
          }
        }, [_vm._v("多店铺")]) : _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "warning"
          }
        }, [_vm._v("怡康优选")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "总数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "时间"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "活动专题分享次数统计",
      "name": "active"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList5
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "active_id",
      "label": "活动id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "分享类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == '0') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "success"
          }
        }, [_vm._v("商品")]) : (scope.row.type == '1') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("活动")]) : (scope.row.type == '2') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("其他")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "来源"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.origin == '0') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "default"
          }
        }, [_vm._v("其他")]) : (scope.row.origin == '1') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain"
          }
        }, [_vm._v("商城")]) : (scope.row.origin == '2') ? _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "danger"
          }
        }, [_vm._v("多店铺")]) : _c('el-tag', {
          attrs: {
            "size": "mini",
            "effect": "plain",
            "type": "warning"
          }
        }, [_vm._v("怡康优选")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total",
      "label": "总数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "time",
      "label": "时间"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center content-top-padded"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1743804f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1743804f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/workwx/authorize/share.vue
// module id = 2496
// module chunks = 0